module.exports = __webpack_public_path__ + "img/paper-and-calculator.7c847179.jpg";